import { Button, Center, Flex, Heading, FlexProps } from "@chakra-ui/react";
import NavBar from "../Navbar";
import "./styles.css";

interface MainHeaderProps extends FlexProps {
  classNameProp?: string;
  title: string;
  withButton?: boolean;
  style?: React.CSSProperties;
}

const MainHeader = ({
  withButton,
  classNameProp,
  title,
  ...props
}: MainHeaderProps) => {
  const handleButtonClick = () => {
    window.open("https://forms.gle/ynBerfiVpTfy9HrQ8", "_blank");
  };

  return (
    <Flex
      className={classNameProp}
      direction="column"
      align="center"
      justify="center"
      flex="1"
      pb={10}
      {...props}
    >
      <NavBar />

      <Center flexDir="column" gap={8} py={20}>
        <Heading size="2xl" color="gray.100" textAlign="center" px={6}>
          {title}
        </Heading>
        {withButton && (
          <Button onClick={handleButtonClick}>Solicita tu propuesta</Button>
        )}
      </Center>
    </Flex>
  );
};

export default MainHeader;
